import clsx from 'clsx';
import { forwardRef, ReactNode, Ref } from 'react';
import { CardContent } from './CardContent';

interface Props extends BaseProps {
  children: ReactNode;
  fullWidth?: boolean;
  variant?: 'default' | 'outlined';
}

/**
 *
 * Storybook:
 *
 * - [Card](https://www.google.com/)
 *
 * Child Components:
 *
 * - [CardHeader](https://www.google.com/)
 * - [CardContent](https://www.google.com/)
 * - [CardFooter](https://www.google.com/)
 *
 */

const Card = forwardRef(function Card(props: Props, ref: Ref<HTMLDivElement>) {
  const {
    children,
    className,
    fullWidth = false,
    variant = 'default',
    ...rest
  } = props;
  const classes = useStyles();

  return (
    <div
      ref={ref}
      className={clsx(
        classes.default,
        classes.variant[variant],
        { [classes.fullWidth]: fullWidth },
        className
      )}
      {...rest}
    >
      {children}
    </div>
  );
});

const useStyles = () => ({
  default: 'w-fit rounded',
  fullWidth: '!w-full',
  variant: {
    default: 'bg-card-light dark:bg-card-dark shadow-sm',
    outlined:
      'bg-transparent border border-border-light dark:border-border-dark',
  },
});

export { Card, CardContent };
